export class UserChangePassword {
    OldPassword: string;
    NewPassword: string;
    ConfirmPassword: string;
}
